import { EntitySettingBase } from './base';

export class AssetGroupSetting extends EntitySettingBase {
  setUpPreviewEntityNameAndEntityKey() {
    this.previewEntityName = this.i18n.getString(_TL_('Asset group'));
    this.previewEntityKeys = ['AssetGroupName'];
    this.defaultEntityValue = '';
  }
}
